import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Transition,
  TransitionChild,
} from '@headlessui/react'

import type { NotificationDialogProps } from './content'
import { NotificationsDialogContent } from './content'

interface Props {
  isOpen: boolean
  onClose: () => void
}

export const NotificationsDialog = ({
  isOpen,
  onClose,
  ...contentProps
}: Props & NotificationDialogProps) => {
  return (
    <Transition show={isOpen}>
      <Dialog
        onClose={onClose}
        className="absolute z-[60]"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <TransitionChild
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          as={DialogBackdrop}
          className="pointer-events-none fixed inset-0 z-[60] bg-secondary-900/30 transition-opacity dark:bg-secondary-900/60"
        />

        <div className="pointer-events-none fixed bottom-0 right-0 top-0 z-[70] h-full w-full max-w-[503px]">
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="ease-in duration-200"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <DialogPanel className="pointer-events-auto relative h-full w-full bg-card">
              <NotificationsDialogContent {...contentProps} />
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  )
}
